import { memo, useCallback, useEffect, useState } from "react"
import { GeoJSON } from "react-leaflet"
import { useTranslation } from 'react-i18next'
import { GET } from '../../../../frameworks/HttpClient'
import { URL_GEOGRAPHY } from '../../../../constants/urls'
import LayerOverlay from '../../../map/layers/overlays/LayerOverlay'
import { GeographyLayer } from '../../../../constants/string'
import Icon, { InfoCircleOutlined } from "@ant-design/icons"
import { Popover } from "antd"


const GeographyOverlay = ({ type, province, onSelect, onLoad }) => {
  const { t } = useTranslation()
  const [isActive, setIsActive] = useState(false)
  const [layers, setLayers] = useState([])

  const fetchLayer = useCallback(() => {
    if (!isActive) return
    onLoad?.(() => (
      GET(`${URL_GEOGRAPHY.LAYER_DETAIL}${type}/`, { province: province?.id })
        .then((response) => setLayers(response.data.results))
        .catch(() => {})
    ))
  }, [type, province?.id, onLoad, isActive])

  useEffect(() => {
    fetchLayer()
    return () => setLayers([])
  }, [fetchLayer])

  return (
    <LayerOverlay
      name={type}
      title={
        <span style={{ color: GeographyLayer.Colors[type] }}>
          {t(GeographyLayer.Labels[type])}
          <Popover 
            overlayStyle={{ width: "640px"}} 
            title={`${t(GeographyLayer.Labels[type])}`}
            content={`${t(GeographyLayer.Descriptions[type])}`}>
            <InfoCircleOutlined  style={{marginLeft: 4}}/>
          </Popover>
        </span>}
      onChange={checked => {
        if (checked) {
          onSelect?.(true)
          setIsActive(true)
          fetchLayer()
        }
        else {
          onSelect?.(false)
          setIsActive(false)
          setLayers([])
        }
      }}
    >
      {layers.map(({ polygons }) => <GeoJSON style={{ color: GeographyLayer.Colors[type] }} data={JSON.parse(polygons)} />)}
    </LayerOverlay>
  )
}

export default memo(GeographyOverlay)
